import React from 'react';
import Helmet from 'react-helmet';
import LAPCompanySelection from '../LAP/CompanyDetails/CompanyDetailsComponent/CompanyType/LAPCompanySelection';
import CustomSideBar from '../../common/components/Sidebar/Sidebar';
import Header from '../../common/components/Header/Header';
import SideImage from '../../images/icons/KYCComplete.svg';
import { siteTitle } from '../../../data/SiteConfig';
import { navigate } from 'gatsby';
import { staticData } from 'gatsby-env-variables';
const LAPStarterScreen = () => (
  <React.Fragment>
    <Helmet title={`Income Details | ${siteTitle}`} />
    <div className="bg-grey-950 relative h-full overflow-auto font-roboto text-sm font-normal m-0 p-0">
      <div className=" min-h-screen flex pt-17 md:pt-0">
        <CustomSideBar />
        <div className="flex-1  w-full widhtMd max-screen">
          <Header />
          <div className="flex-1 pb-8 flex-row w-full relative">
            <div className="w-full flex">
              <div className="md:ml-5  w-full md:w-8/12 px-2 md:bg-white min-h-screen md:py-2 block">
                <p
                  className="font-roboto ml-auto mr-3 float-right mt-2 pb-2 text-red-100 font-medium text-base bottom-0 mx-auto md:mr-5 cursor-pointer float-right"
                  onClick={() =>
                    navigate(staticData?.dashboardURl || '/app/dashboard')
                  }
                >
                  Skip and go to dashboard
                </p>

                <LAPCompanySelection />
              </div>
              <div className="w-1/4 hidden md:block">
                <img
                  className="inset-x-0 bottom-0"
                  src={SideImage}
                  style={{ position: 'fixed', bottom: 0, left: '80%' }}
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </React.Fragment>
);

export default LAPStarterScreen;
